import React from 'react';
import { get } from 'lodash';
import { branch, renderNothing, renderComponent } from 'recompose';
import LoadingScreen from '../LoadingScreen/LoadingScreen';

/**
 *
 * @param propPaths (Array|string) same as lodash's get path parameter
 * @param showLoading if a loading indicator should be shown
 * @param fullscreen if the loading indicator should be position=fixed
 * @returns {*}
 */
const requireProps = (propPaths, showLoading = false, fullscreen = false) =>
  branch(
    props => propPaths.some(propPath => typeof get(props, propPath) === 'undefined'),
    showLoading ? renderComponent(
      () => <LoadingScreen isLoading position={fullscreen ? 'fixed' : undefined} />,
    ) : renderNothing,
  );

export default requireProps;
